export enum AgoraEvents {
    NetworkQuality = "network-quality"
}